import { getDealerContractList } from '@/api/pc-api/v1/{authInfoId}/contract/list/dealer';
import { getDealer } from '@/api/pc-api/v1/{authInfoId}/dealer';
import { getPrice } from '@/api/pc-api/v2/{authInfoId}/price';

export const getDealerContractPageData = async (id: string) => {
  const {
    data: { data: dealer }
  } = await getDealer(id);

  const [
    { data: contractListData },
    {
      data: { data: priceTableData }
    }
  ] = await Promise.all([getDealerContractList(id, 1), getPrice(dealer.id, dealer.bizType)]);

  return { data: { dealer, contractListData, priceTableData } };
};
